export enum WearerGroupEnum {
    resident = 'Resident',
    caregiver = 'Caregiver',
    asset = 'Asset',
}